import { render, staticRenderFns } from "./Product_4.vue?vue&type=template&id=b041605a&scoped=true"
import script from "./Product_4.vue?vue&type=script&lang=js"
export * from "./Product_4.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/PC.scss?vue&type=style&index=0&id=b041605a&prod&lang=scss&scoped=true&external"
import style1 from "./Product_4.vue?vue&type=style&index=1&id=b041605a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b041605a",
  null
  
)

export default component.exports